import { DateFields } from '@sigma-frontend-libs/commons'
import { OrderDirections } from '@sigmasms/shared-types'

import { permissionPresets, serviceTemplate, services } from '@/utils'

export default {
  mixins: [
    serviceTemplate({
      serviceName: services['otp-settings/widgets'],

      backendGeneration: 'nest',

      outputFilter(result) {
        if (!this.checkPermissions(`advanced.${services.users}.find`, permissionPresets.resellerUp)) {
          result.ownerId = result.ownerId || this.account.id
        }

        return result
      },

      find: {
        defaultFilter: {
          scopes: [ 'full' ],
          order: [ [ DateFields.createdAt, OrderDirections.DESC ] ],
          search: undefined,
          ownerId: undefined,
          isActive: true,
          isBlocked: false
        }
      },
      get: {
        params: {
          query: {
            scopes: [ 'full' ]
          }
        }
      },
      update: {
        params: {
          query: {
            scopes: [ 'full' ]
          }
        }
      },
      create: { redirect: true },

      has: {
        search: false,
        clone: false,
        tabs: false
      },

      titlePath: 'name',
      formClass: ''
    })
  ]
}
